import React from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
} from '@welldev-group/rcl-table';
import AffiliateRow from './AffiliateRow';
import TablePlaceholder from '../../../../shared/components/Placeholder/TablePlaceHolder';

const AffiliateTable = props => (
  <Table className="affiliate-list__table">
    <TableHead>
      <TableRow>
        <TableHeader>
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.affiliate_name" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.account_manager" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.active_users" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.total_bookings" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.total_issued_tickets" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.plan" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.workspaces" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.last_login" />
        </TableHeader>
        <TableHeader align="center">
          <I18nText id="affiliate_three_sixty.affiliate_list.attributes.actions" />
        </TableHeader>
      </TableRow>
    </TableHead>
    <TableBody className="affiliate-list__table-row">
      {props.isLoading ? (
        <TablePlaceholder numberOfColumn={9} numberOfRows={10} />
      ) : (
        props.affiliates.map(affiliate => (
          <AffiliateRow
            key={affiliate.id}
            affiliateId={affiliate.id}
            accountManager={affiliate.accountManager.name}
            affiliateName={affiliate.clientName}
            activeUsers={Number(affiliate.activeUsers).toLocaleString()}
            bookings={Number(affiliate.bookingsTotal).toLocaleString()}
            issuedTickets={Number(affiliate.totalIssuedTickets).toLocaleString()}
            profile={Number(affiliate.travelersTotal).toLocaleString()}
            plan={affiliate.plan}
            subscriptionPeriod={affiliate.subscriptionPeriod}
            workspaces={Number(affiliate.workspaces).toLocaleString()}
            lastLogin={affiliate.lastLogin}
            showDetailsUrl={affiliate.showDetailsUrl}
            deactivatedAffiliates={props.deactivatedAffiliates}
            onConfirmationModalDismiss={props.onConfirmationModalDismiss}
            totalChannels={affiliate.totalChannelCount}
          />
        ))
      )}
    </TableBody>
  </Table>
);

AffiliateTable.defaultProps = {
  affiliates: PropTypes.arrayOf(
    PropTypes.shape({
      lastLogin: null,
      totalChannelCount: 0,
    }),
  ),
  isLoading: true,
};

AffiliateTable.propTypes = {
  affiliates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      clientName: PropTypes.string.isRequired,
      activeUsers: PropTypes.number.isRequired,
      plan: PropTypes.string.isRequired,
      workspaces: PropTypes.number.isRequired,
      lastLogin: PropTypes.string,
      showDetailsUrl: PropTypes.string.isRequired,
      totalChannelCount: PropTypes.number,
    }),
  ),
  isLoading: PropTypes.bool,
  deactivatedAffiliates: PropTypes.bool.isRequired,
  onConfirmationModalDismiss: PropTypes.func.isRequired,
};

export default AffiliateTable;
